import { render, staticRenderFns } from "./VehicleCostButton.vue?vue&type=template&id=2498d703"
import script from "./VehicleCostButton.vue?vue&type=script&lang=js"
export * from "./VehicleCostButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports